<template>
	<div class="main-about">
		<navigations :path="path"></navigations>

		<img class="about-img" src="../assets/back-5.png" alt="" />

		<div class="container-about">
			<div class="about-center">
				<div class="about-center-left">
					<div class="about-center-left-text">
						<div class="about-center-left-text-title">关于我们</div>
						<span>
							时购圈是一款生活消费服务平台。我们为用户提供丰富的商户与服务信息，帮用户发现各类优质商家，轻松了解服务与产品详情。用户可以在时购圈组织和参加线下活动，通过真实社交场景认识更多志趣相投的好友。
						</span>
						<span>
							我们也致力于帮助商家解决经营痛点。时购圈为商家提供展示与推广的机会，同时提供数字化运营工具，帮助商家精准营销，扩大用户群，增加跨界收入，实现多项收益。
							时购圈，简单连接生活，创造无限商机。
						</span>
					</div>
					<div class="about-center-left-text">
						<div class="about-center-left-text-title">时购圈1.0</div>
						<span>
							时购圈 APP 是一款全新打造的集社交、组队、聊天交友、支付消费与线下拼玩于一体的应用程序，它专注于 IORE (INTERNETIZATION OF THE REAL ECONOMY)
							实体经济互联网化，连接用户与商家，推动实体经济向移动互联网转型。我们满足用户的生活消费与社交需求的同时也帮助商家的运营与提升，构建覆盖生活各场景的消费服务生态体系。
							时购圈整合线下商家资源的同时，增设创新匹配组队系统，能够让用户快速找到志同道合的朋友，一起参加线下活动。无论是桌游、密室逃脱，还是 K
							歌、打球，甚至和陌生的朋友喝一杯聊聊天，时购圈都能帮您实现。在这里，您也可以和刚认识的 TA 一起吃顿火锅，享受一场期待已久的电影。
						</span>
					</div>
					<div class="">
						<img class="about-center-left-img" src="../assets/back-3.png" alt="" />
					</div>
				</div>
				<div class="about-center-right">
					<img class="about-center-right-img" src="../assets/phone.png" alt="" />
				</div>
			</div>

			<div class="about-line"></div>

			<div class="about-center about-center-pc">
				<img class="about-map" src="../assets/about-1.png" alt="" />
			</div>

			<div class="about-line"></div>

			<div class="about-hint about-pc-hide">时购圈五年发展规划</div>

			<div class="about-center-phone">
				<img class="about-map" src="../assets/about-phone-1.png" alt="" />
			</div>

			<div class="about-hint">时购圈更多板块即将上线</div>

			<div class="about-center-bottom">
				<img class="about-map" src="../assets/index-1.png" alt="" />
			</div>

			<div class="about-center-phone">
				<img class="about-map about-map-phone" src="../assets/about-phone-2.png" alt="" />
			</div>
		</div>
		<tabbar></tabbar>
	</div>
</template>

<script>
export default {
	name: 'about',
	props: {
		msg: String
	},
	data() {
		return {
			path: '/about'
		};
	},
	methods: {}
};
</script>

<style>
html,
body {
	width: 100%;
	height: 100%;
	margin: 0;
	overflow: auto;
}

.main-about {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
}

.container-about {
	width: 100%;
	min-height: 100%;
	padding: 15% 15% 0 15%;
	box-sizing: border-box;
}

.about-center {
	width: 100%;
	height: 850px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: flex-start;
	justify-content: center;
	align-items: flex-start;
}

.about-center-left {
	width: 50%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: flex-start;
	align-items: flex-start;
	justify-content: center;
}

.about-center-left-text {
	text-align: left;
	margin-bottom: 30px;
}

.about-center-left-text-title {
	font-size: 48px;
	margin-bottom: 10px;
}

.about-center-left-text span {
	color: #808080;
	font-size: 16px;
	letter-spacing: 2px;
}

.about-center-right {
	width: 50%;
}

.about-center-right-img {
	width: 62%;
}

.about-center-left-img {
	border-radius: 20px;
}

.about-center-bottom {
	width: 100%;
	height: 650px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: flex-start;
	justify-content: center;
	align-items: flex-start;
}

.about-line {
	width: 100%;
	height: 1px;
	background-color: rgba(0, 0, 0, 0.5);
	margin-top: 100px;
	margin-bottom: 100px;
}

.about-map {
	width: 100%;
}

.about-hint {
	width: 100%;
	margin-top: 100px;
	margin-bottom: 100px;
	font-weight: 900;
	letter-spacing: 5px;
	font-size: 48px;
}

.about-img {
	display: none;
}

.about-center-phone {
	display: none;
}

.about-pc-hide {
	display: none;
}

@media screen and (max-width: 768px) {
	.main-about {
		padding-top: 70px;
	}

	.container-about {
		padding: 5% 5% 0 5%;
	}

	.about-center {
		height: auto;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		margin-top: 0;
	}

	.about-center-left {
		width: 100%;
	}

	.about-center-right {
		display: none;
	}

	.about-center-left-img {
		width: 100%;
	}

	.about-center-bottom {
		display: none;
	}

	.about-img {
		width: 100%;
		display: flex;
	}

	.about-center-left-text-title {
		font-size: 24px;
		font-weight: bolder;
	}

	.about-center-left-text span {
		font-size: 12px;
	}

	.about-center-pc {
		display: none;
	}

	.about-line {
		display: none;
	}

	.about-center-phone {
		display: flex;
	}

	.about-hint {
		font-weight: bolder;
		font-size: 24px;
		margin: 30px 0;
		display: flex;
		justify-content: flex-start;
		letter-spacing: 3px;
	}

	.about-map-phone {
		width: 85%;
	}
}
</style>
